import {Utilisateur} from './../../../interface/api/Utilisateur';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {api} from './../../../api/api-dictionnary';
import {HydraCollection} from './../../../class/generic/hydra-collection';
import {HydraService} from './../../../core/services/hydra.service';
import {AuthentificationService} from './../../../core/services/authentification.service';
import {UtilisateurRole} from './../../../class/api/UtilisateurRole';
import { Component, OnInit, inject } from '@angular/core';
import {ToolsService} from '../../services/tools/tools.service';
import {ROLE_KEYS} from '../../../core/consts/roles';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-modal-roles-utilisateur',
    templateUrl: './modal-roles-utilisateur.component.html',
    styleUrls: ['./modal-roles-utilisateur.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatButton, MatRadioGroup, FormsModule, MatRadioButton, MatDialogActions, MatDialogClose, UpperCasePipe]
})
export class ModalRolesUtilisateurComponent implements OnInit {
    private authService = inject(AuthentificationService);
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<any>>(MatDialogRef);
    data = inject<Utilisateur>(MAT_DIALOG_DATA);
    toolService = inject(ToolsService);

    public user: Utilisateur = null;
    public rolesUser: UtilisateurRole[];
    public modification = false;
    public roles = []; // 0 => { checked, label}
    public wantedRole: string;

    constructor() {
        if (this.data && this.data != null) {
            this.user = this.data;
            this.rolesUser = this.user.utilisateurRoles as UtilisateurRole[];
            this.loadRoles();
        }
    }

    public loadRoles() {
        if (!this.authService.isAdmin()) {
            return;
        }

        this.hydraService
            .getList(api.roleUtilisateur, true)
            .subscribe((res: HydraCollection) => {

                const roles = res.getMember()
                    .filter(
                        (item: UtilisateurRole) => item.code != ROLE_KEYS.president
                            && item.code != ROLE_KEYS.associate //le rôle ASSOCIATE est attribué dans la gestion des Cofinanceurs
                            && (
                            (item.code != ROLE_KEYS.superadmin && item.code != ROLE_KEYS.partner) || this.authService.isSuperAdmin()
                        )
                    )
                    .map(
                        (item, index) => ({
                                ...item,
                                id: item['@id']
                            })
                    );

                const roleCandidat = {
                    ['@id']: null,
                    id: null,
                    code: null,
                    label: 'CANDIDAT',
                    ['@type']: 'UtilisateurRole'
                };
                roles.push(roleCandidat);

                this.roles = roles;
            });
    }

    public saveRole() {
        if (!this.authService.isAdmin(false)) {
            return;
        }

        const data = {
            utilisateur: this.user['@id'],
            roles: [],
        };

        if (this.wantedRole != null) {
            data['roles'].push(this.wantedRole);
        }

        this.hydraService
            .post(api.utilisateurChangeRole, data)
            .subscribe(res => {
                this.toolService.notificationSuccess(
                    'La modification des rôles a bien été prise en compte',
                    3000
                );
                this.dialogRef.close(this.wantedRole === '/api/utilisateur_roles/2' ? this.wantedRole : true);
            });
    }

    public getCurrentRole(): string | null {
        if (this.user.utilisateurRoles.length > 0) {
            return this.user.utilisateurRoles[0].code;
        }
        return null;
    }

    ngOnInit() {
    }
}
